import { useState } from "react";
import { useLocation } from "react-router-dom";

import { AppHeader } from "../../components/header/header";
import { capitalizeLink } from "../../_helpers/utility-methods";
import { ToggleSwitch } from "../../components/utilities/toggle-switch";
import { BodySpacer } from "../../components/utilities/body-spacer";
import { TranslationService } from "../../components/services/service";
import { NewsLetterBox } from "../../components/footer/newsletter";
import { ContactForm } from "../../components/footer/contact-map";
import { AppFooter } from "../../components/footer/footer";

export const Services = () => {

    const { pathname } = useLocation();

    const [opened, setOpened] = useState(null);

    const toggleOpen = (indx) => {
        opened !== indx ? setOpened(indx) : setOpened(null);
    }

    return (
        <div className="page-body">
            <AppHeader />
            <BodySpacer />
            <div 
                className="page-pic-box"
                style={{backgroundImage:'url(/images/services.jpg)'}}
            >
                <div className="page-pic-bg">
                    <div className="pre-txt" />
                    <div className="page-bg-text">
                        <p>UEST</p>
                        <p>SERVICES</p>
                        <div>
                            <button className="path-btn">
                                <a href="/">Home/</a>{capitalizeLink(pathname)}
                            </button>
                        </div>
                    </div>
                    <div className="pre-txt" />
                </div>
            </div>
            <ToggleSwitch 
                onSwitch={() => toggleOpen(1)} 
                caption={"Translation services"} 
                switched={opened === 1}
            />
            <TranslationService opened={opened === 1} 
            />
            <ToggleSwitch 
                onSwitch={() => toggleOpen(2)} 
                caption={"Work contrats and Visas"} 
                switched={opened === 2}
            />
            <TranslationService opened={opened === 2} />
            <ToggleSwitch 
                onSwitch={() => toggleOpen(3)} 
                caption={"Flight reservations and ticket purchase"} 
                switched={opened === 3}
            />
            <TranslationService opened={opened === 3} />
            <ToggleSwitch 
                onSwitch={() => toggleOpen(4)} 
                caption={"Visa card online payments"} 
                switched={opened === 4}
            />
            <TranslationService opened={opened === 4} />
            <NewsLetterBox />
            <ContactForm />
            <AppFooter />
        </div>
    )
}